import { Card } from '@mui/material'
import React from 'react'
import { RecordContextProvider, ResourceContextProvider } from 'react-admin'

import SpeedingSection from '../../components/InfoWindow/SpeedingSection'

const HoverInfoWindow = ({ record, speedingData, x, y }) => {
  return (
    <ResourceContextProvider value="vehicle-telematics">
      <RecordContextProvider value={record}>
        <Card
          elevation={4}
          sx={{
            position: 'absolute',
            left: x + 12,
            top: y - 12,
            transform: 'translateY(-100%)',
            pointerEvents: 'none',
            minWidth: 240,
            background: 'rgba(255,255,255,0.95)',
            borderRadius: 2,
            p: 1.5,
            backdropFilter: 'blur(8px)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
            border: '1px solid rgba(0,0,0,0.1)',
          }}
        >
          <SpeedingSection event_data={speedingData} />
        </Card>
      </RecordContextProvider>
    </ResourceContextProvider>
  )
}

export default HoverInfoWindow
